export enum ModulePermission {
	READ = "READ",
	CREATE_EDIT_DELETE_OWNED = "CREATE_EDIT_DELETE_OWNED",
	EDIT_ALL = "EDIT_ALL"
}

export enum Modules {
	OPPORTUNITY = "OPPORTUNITY",
	SALES_AUTOMATION = "SALES_AUTOMATION",
	PIPELINE = "PIPELINE",
	CUSTOM_FIELD = "CUSTOM_FIELD",
	USER = "USER",
	TAX_SETUP = "TAX_SETUP",
	EMAIL = "EMAIL",
	DKIM = "DKIM",
	EMAIL_TEMPLATE = "EMAIL_TEMPLATE",
	CUSTOM_EMAIL_TEMPLATE = "CUSTOM_EMAIL_TEMPLATE",
	REPORT = "REPORT",
	CLIENT_COMPANY = "CLIENT_COMPANY",
	SALES_ACTIVITY = "SALES_ACTIVITY",
	ITEM = "ITEM",
	ROLES_PERMISSION = "ROLES_PERMISSION",
	APPROVAL_AUTOMATION = "APPROVAL_AUTOMATION",
	TEMPLATE = "TEMPLATE",
	DOCUMENT = "DOCUMENT",
	QBR = "QBR",
	ASSESSMENT = "ASSESSMENT",
	QUOTE_BLOCK = "QUOTE_BLOCK",
	PURCHASE_ORDER = "PURCHASE_ORDER",
	MS365_ASSESSMENT = "MS365_ASSESSMENT",
	SUPPLIER = "SUPPLIER"
}
